export enum ViewEnum {
    VideoTutorialPlatform = -2,
    VideoTutorial = -1,
    Tutorial = 0,
    FirstStep = 1
}
